export const CountDownWrapper = `flex gap-4 justify-center text-lg lg:text-2xl`
export const CountDownItem = `flex flex-col gap-2 items-center`

export const CountDownNumbers = 'font-bold'

export const CountDownDots = `${CountDownNumbers} self-end`
